<template>
    <div>

        <div v-if="isPhone" style="padding: 10px">

            <div style="margin-bottom: 10px">
                <search-bar/>
            </div>

            <div style="margin-bottom: 10px">
                <van-dropdown-menu>
                    <van-dropdown-item :value="selectedSubjectId+ ''" @change="selectBySubject"
                                       :options="mobileSearchSubjectList" />
                    <van-dropdown-item v-model="type" :options="courseTypeOption" @change="changeType"/>

                    <van-dropdown-item v-model="liveType" :options="courseIsLive" @change="changeLiveType"/>
                </van-dropdown-menu>
            </div>


            <div class="" v-show="!isHaveSearch">
                <ul>
                    <a-row :gutter="{ xs: 8, sm: 8, md: 16, lg: 16 }">
                        <li v-for="item in 6 " :key="item">
                            <a-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
                                <spin class="spin"></spin>
                            </a-col>
                        </li>
                    </a-row>
                </ul>
            </div>

            <div v-show="isHaveSearch">
                <a-row :gutter="{ xs: 8, sm: 8, md: 16, lg: 16 }">
                    <div style="font-size: 18px;text-align: center;margin: 50px" v-if="isEmpty">暂无相关搜索结果，换个关键词试试吧 : )
                    </div>
                    <ul v-else>
                        <li class="list-item" v-for="item in courseList " :key="item.courseId">
                                <CourseListItem :course-info="item" />
                        </li>
                    </ul>
                </a-row>

                <div class="bottomPage" style="clear: both">
                    <a-pagination @change="onChange" :current=pageNum :defaultPageSize=pageSize
                                  :total='total' />
                </div>
            </div>
        </div>

        <div v-else class="search-course">
            <div class="route">
                <a-breadcrumb>
                    <a-breadcrumb-item href="">
                        <span></span>
                        <router-link to="/">
                            <a-icon type="home" />
                            首页
                        </router-link>
                    </a-breadcrumb-item>
                    <a-breadcrumb-item href="">
                        <span>课程搜索</span>
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </div>
            <div class="subject-list condition-list clear-float">
                <h3>专题：</h3>

                <div class="subject-list-box">
                   <span @click="selectBySubject(item.subjectId)" v-for="item in searchSubjectList"
                         :key="item.subjectId"
                         :class="{active:item.subjectId==selectedSubjectId}"> {{item.subjectTitle}}</span>
                </div>
            </div>

            <header class="course-type condition-list">
                <h3>类型：</h3>
                <span @click="changeType('')" :class="{active:type===''}">全部类型</span>
                <span @click="changeType('free')" :class="{active:type==='free'}">免费课程</span>
                <span @click="changeType('pay')" :class="{active:type==='pay'}">付费课程</span>
                <span @click="changeType('boutique')" :class="{active:type==='boutique'}">精品课程</span>
                <span @click="changeType('discount')" :class="{active:type==='discount'}">限时折扣课程</span>
            </header>
            <!--            courseIsLive-->
            <header class="course-type condition-list">
                <h3>方式：</h3>
                <span @click="changeLiveType('')" :class="{active:liveType===''}">全部方式</span>
                <span @click="changeLiveType('live')" :class="{active:liveType==='live'}">直播课程</span>
                <span @click="changeLiveType('recorded')" :class="{active:liveType==='recorded'}">录播课程</span>
            </header>


            <div class="classList" v-show="!isHaveSearch">
                <dl>
                    <dt v-for="item in 5" :key="item">
                        <spin class="spin"></spin>
                    </dt>
                </dl>
            </div>
            <div class="classList" v-show="isHaveSearch">
                <div style="font-size: 20px;text-align: center;margin: 50px" v-if="isEmpty">暂无相关搜索结果，换个关键词试试吧 : )
                </div>

                <ul v-else>
                    <li v-for="item in courseList" :key="item.courseId">
                        <course-list-item :course-info="item" />
                    </li>
                </ul>

                <div class="bottomPage" style="clear: both">
                    <a-pagination
                        @change="onChange"
                        @showSizeChange="onChange"
                        :current=pageNum
                        :show-size-changer="true"
                        :show-less-items="true"
                        :defaultPageSize=pageSize
                        :total='total'
                        :pageSizeOptions="pageSizeOptions"
                    />
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import {search} from "@api/course-api"
    import {DISPATCH_INIT_SUBJECT_LIST} from "@constants/action-type/subject-action-type";
    import {createNamespacedHelpers} from "vuex";
    import {COMMIT_CHANGE_SUBJECT_SELECTED} from "@constants/mutation-type/subject-mutation-type";
    import CourseListItem from "@components/course/CourseListItem";
    import spin from "@components/loading/Spin"
    import SearchBar from "@components/layout/header/SearchBar";

    const {mapState, mapGetters} = createNamespacedHelpers('subject');
    import common from "../mixin/common";

    export default {
        name: "searchClass",
        mixins: [common],
        components: {
            CourseListItem, spin, SearchBar,
        },
        data() {
            return {
                isPhone: false,
                courseList: [],
                isHaveSearch: true,
                //当前页数
                pageNum: 1,
                //每页容量
                pageSize: 15,
                //    总数
                total: 0,
                pageSizeOptions: ['10', '15', '20'],

                // 专题
                type: '',
                //全部类型
                courseTypeOption: [
                    {text: '全部类型', value: ''},
                    {text: '免费课程', value: 'free'},
                    {text: '付费课程', value: 'pay'},
                    {text: '精品课程', value: 'boutique'},
                    {text: '限时折扣课程', value: 'discount'},
                ],
                //    直播还是录播
                courseIsLive: [
                    {text: '全部方式', value: ''},
                    {text: '直播课程', value: 'live'},
                    {text: '录播课程', value: 'recorded'},
                ],
                liveType: "",
            }

        },
        created() {
            //
            if (this.isMobile) {
                this.isPhone = true
            }
            //
            // 重新初始化分类列表
            this.$store.dispatch(DISPATCH_INIT_SUBJECT_LIST);
            //搜索结果
            this.type = this.$route.query.type || '';
            this.$store.commit("changeSearchKeyword", {searchKeyword: this.$route.query.keyword});
            this.selectBySubject(this.$route.query.subject);
            this.onSearch();
        },
        methods: {
            //选择分类是否为免费
            changeType(type) {
                //没出结果前防止重复点击
                if (!this.isHaveSearch) return;

                this.type = type;
                this.changeRoute();
            },
            changeLiveType(liveType) {
                //没出结果前防止重复点击
                if (!this.isHaveSearch) return;

                this.liveType = liveType
                this.changeRoute();
            },
            //    翻页
            onChange(current, pageSize) {
                this.pageNum = current;
                this.pageSize = pageSize;
                this.onSearch();
            },
            //课程分类选择
            selectBySubject(subjectId) {
                if (this.isHaveSearch) {
                    this.pageNum = 1;
                    this.$store.commit(COMMIT_CHANGE_SUBJECT_SELECTED, {
                        subjectId
                    });
                    this.changeRoute();
                } else {
                    return
                }
            },
            changeRoute() {
                this.$router.push({
                    path: '/other/search',
                    query: {
                        keyword: this.searchKeyword,
                        type: this.type,
                        subject: this.selectedSubjectId,
                        courseType: this.liveType,
                    }
                }).catch(err => err)
            },
            onSearch() {
                this.isHaveSearch = false
                search({
                    keyword: this.searchKeyword,
                    type: this.type,
                    subjectId: this.selectedSubjectId,
                    courseType: this.liveType
                }, this.pageNum, this.pageSize).then((res) => {
                    this.total = res.total;
                    this.isHaveSearch = true;
                    // this.nullList = []
                    this.courseList = res.courseList
                }).catch((err) => {
                    console.error(err)
                });
            },
        },
        computed: {
            isEmpty() {
                return !this.courseList || this.courseList.length === 0
            },
            ...mapState([
                "subjectList",
                "selectedSubjectId"
            ]),
            ...mapGetters([
                "searchSubjectList"
            ]),
            mobileSearchSubjectList() {
                return this.searchSubjectList.map(item => ({
                    text: item.subjectTitle,
                    value: item.subjectId + ''
                }))
            },
            searchKeyword() {
                return this.$store.state.searchKeyword;
            }
        }, watch: {
            searchKeyword() {
                this.changeRoute();
            },
            $route() {
                this.onSearch();
                if (this.$route.query.subject) {
                    this.$store.commit(COMMIT_CHANGE_SUBJECT_SELECTED, {
                        subjectId: this.$route.query.subject
                    });
                }
            }
        },
        beforeDestroy() {
            this.$store.commit("changeSearchKeyword", {searchKeyword: ''});
        }
    }
</script>

<style scoped lang="less">

    @import "../styles/course.less";
    /*搜索框*/
    .list-item{
      width: 50%;
      display: inline-block;
      padding:0 4px;
    }
    /deep/ .ant-input-group-wrapper {
        width: 100%;
        /*max-width: 400px;*/
        margin: 0 auto;
        /*height: 24px;*/
    }

    .search-bar-input {
        /deep/ .ant-input-lg {
            height: 30px;
            font-size: 14px;
        }
    }

    /deep/ .search-bar-button {
        height: 30px;
        font-size: 14px;
        text-align: center;
        text-indent: -4px;
    }

    .subject-list {
        width: 1200px;
        margin: 2px auto;
        padding: 10px 20px;
        background: #F4F4F4;
        line-height: 30px;

        .subject-list-box {
            margin-left: 50px;
        }
    }

    .condition-list {
        padding: 10px;
        background: #F4F4F4;

        h3 {
            float: left;
            line-height: 30px;
            color: rgba(0, 0, 0, 0.5);
        }

        span {
            display: inline-block;
            min-width: 70px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin: 0 6px;
            padding: 0 5px;

        }

        span:hover {
            cursor: pointer;
        }

        .active {
            color: white;
            background: #00CF8C;
        }
    }

    .course-type {
        margin: 2px 0;
    }

    .bottomPage {
        text-align: center;
        margin-bottom: 20px;
    }

    .search-course {
        min-height: calc(100vh - 270px);
        width: 1200px;
        margin: 0 auto;
    }

    .route {
        width: 1200px;
        margin: auto;
        padding: 20px 0 20px 10px;
        font-size: 16px;
    }

    /deep/ .ant-breadcrumb-link {
        font-size: 16px;
    }

    .classList {
        width: 1200px;
        overflow: hidden;
        margin: auto;

        dl dt {
            float: left;
            width: 20%;
            position: relative;
            border-radius: 3px;
            overflow: hidden;
            padding: 7px 7px 10px;
            margin-bottom: 20px;
            cursor: pointer;
        }
    }

</style>
